import TreemapViz from '../vizs/TreemapViz'
import BaseComponent from './BaseComponent'

export default class TreemapComponent extends BaseComponent {
  static vizClass = TreemapViz
  static componentLabel = 'Treema'
  static dataFormat = [
    { index: 0, axis: '', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: '', types: [Number], role: 'value', roleLabel: 'Value' },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: '',
    centerValue: {
      nonEditable: true,
    },
    centerTopText: {
      nonEditable: true,
    },
    centerBottomText: {
      nonEditable: true,
    },

    donutThickness: {
      nonEditable: true,
    },
  }
}
